// PrivacyPolicyPage.js
import { useEffect, useState } from "react";
import React from 'react';
import './PurchasePolicy.css'

const PurchasePolicy = () => {
    const [content, setContent] = useState("");

    useEffect(() => {
        fetch("/purchase-policy.html")
            .then((response) => response.text())
            .then((html) => setContent(html))
            .catch((error) => console.error("Error loading purchase policy:", error));
    }, []);

    return (
        <section className='purchase-policy-container'>
            <div className='purchase-policy-content'>
                <div className="purchase-policy-body" dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </section>
    );
};

export default PurchasePolicy;
